import React from "react";
import Title from "../../../components/title/Title";
import { MainContainer } from "../../styles/sharedStyles";
import Section from "../../../components/section/Section";
import { tokens } from "../../../../theme";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Paper,
  useMediaQuery,
} from "@mui/material";

import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import GrilleDesRecettes from "./GrilleDesRecettes";

const ListeDeRecettesMainPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if it's a mobile screen

  return (
    <MainContainer>
      <Title title="Les recettes" summary="Food and Joy" />

      <Box
        m={isMobile ? 1 : 2} // Adjust margin for mobile screens
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Grid container justifyContent="center">
          <Grid
            item
            xs={12}
            sm={10}
            md={8}
            lg={6}
            sx={{
              padding: isMobile ? "1rem" : "2rem", // Add padding for better spacing
            }}
          >
            {" "}
            <GrilleDesRecettes />
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  );
};

export default ListeDeRecettesMainPage;
